import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const etagAtom = atom<Record<string, string | null>>({});
export const selectedModelStoredAtom = atomWithStorage<string[]>(
  "selectedModelStored",
  []
);
export const pickedModelsStoredAtom = atomWithStorage<string[]>(
  "pickedModelsStored",
  []
);

// Set when Genie wrote to a conversation (a message, a retry, a rating, a
// stop). That chat, if open, reloads its newest messages.
export const genieWroteConversationAtom = atom<{
  conversationId: string;
} | null>(null);
